"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeefyVaultContract = void 0;
const ethers_1 = require("ethers");
const abi_1 = require("../../../abi/abi");
const address_1 = require("../../../utils/address");
class BeefyVaultContract {
    constructor(address, provider) {
        if (!(0, address_1.validateContractAddress)(address)) {
            throw new Error('Invalid Vault address for Beefy contract');
        }
        this.contract = new ethers_1.Contract(address, abi_1.abi.vault.beefy, provider);
    }
    createDepositAll() {
        return this.contract.depositAll.populateTransaction();
    }
    createWithdrawAll() {
        return this.contract.withdrawAll.populateTransaction();
    }
}
exports.BeefyVaultContract = BeefyVaultContract;
